import React, { useMemo } from 'react';
import { useScrollIndicator } from 'app/hooks/useScrollIndicator';
import { filter, map } from 'underscore';
import classNames from 'classnames';
import { Link } from 'app/shared/link/link';
import { Typography } from 'antd';

export const NavbarNav = ({ childrenTypes, activeType }) => {
    const typeIds = useMemo(() => {
        return map(childrenTypes, (type) => type.id);
    }, [childrenTypes]);
    const activeID = useScrollIndicator(typeIds);

    return childrenTypes?.length ? (
        <div className={'nav-container'}>
            {map(childrenTypes, ({ id, name }) => {
                return (
                    <Link
                        to={`categories/${activeType}#${id}`}
                        key={id}
                        className={classNames('nav__item', {
                            nav__item_active: id === activeID,
                        })}
                    >
                        {name}
                    </Link>
                );
            })}
        </div>
    ) : null;
};

export const NavbarNavCompact = ({ links }) => {
    const linkIds = useMemo(() => {
        return filter(
            map(links, ({ url }) => {
                if (url?.startsWith('#')) return url.replace('#', '');
                return null;
            }),
            (item) => item
        );
    }, [links]);
    const activeID = useScrollIndicator(linkIds);

    return (
        <div className={'nav-container'} style={{ flex: 1 }}>
            {map(links, ({ url, title, id }) =>
                url?.startsWith('#') ? (
                    <Link
                        to={`/${url}`}
                        key={id}
                        className={classNames('nav__item', {
                            nav__item_active:
                                url?.replace('#', '') === activeID,
                        })}
                    >
                        {title}
                    </Link>
                ) : (
                    <Typography.Link
                        rel={'noopener noreferrer'}
                        target={'_blank'}
                        href={url}
                        className={classNames('nav__item')}
                    >
                        {title}
                    </Typography.Link>
                )
            )}
        </div>
    );
};
